import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Props from "./props";
import Select from "../../ui/Select";
import getSchoolCategoriesSelector from "../../../../state/selectors/SchoolSelectors/getSchoolCategoriesSelector";
import getSchoolNewFieldSelector from "../../../../state/selectors/SchoolSelectors/getSchoolNewFieldSelector";
import setNewSchoolFieldAction from "../../../../state/actions/SchoolActions/setNewSchoolFieldAction";
import styled from "styled-components";

const NewSchoolCategories: React.FC<Props> = () => {
    const categories = useSelector((state: Store) => getSchoolCategoriesSelector(state));
    const selectedCategories = useSelector((state: Store) => getSchoolNewFieldSelector(state, "categories"));
    const dispatch = useDispatch();
    const setNewSchoolField = useCallback((data: SchoolCategory) => dispatch(setNewSchoolFieldAction(data, "categories")), [dispatch]);
    return (
        <FlexWrapper>
            <Left>Categorie</Left>
            <Right>
                <Select
                    placeholder="Seleziona una categoria"
                    options={categories}
                    value={selectedCategories}
                    isSelectedOption={(option: SchoolCategory) =>
                        selectedCategories.map((selectedCategory: SchoolCategory) => selectedCategory.term_id).indexOf(option.term_id) > -1
                    }
                    getOptionText={(option: SchoolCategory) => option.name}
                    setOptionKey={(option: SchoolCategory) => option.term_id}
                    onOptionClick={(option: SchoolCategory) => setNewSchoolField(option)}
                />
            </Right>
        </FlexWrapper>
    );
};

export default NewSchoolCategories;

const FlexWrapper = styled.div`
    display: flex;
    padding-bottom: 2rem;
`;

const Left = styled.div`
    width: 23%;
    font-weight: 700;
    font-size: 1.1rem;
`;

const Right = styled.div`
    width: calc(100% - 23%);
    font-size: 1.1rem;
`;
